export default __webpack_public_path__ + "static/media/invisible.fa7e2e82.svg";